export default function identity(x) {
  return x;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/utils/identity.js
// module id = null
// module chunks = 